import axios from 'axios';
import get from 'lodash.get';
import { from } from 'rxjs';

import { OrderSearchResultHandler } from './order-search-result';
import { emptyArray } from 'ui-components/default-props/empty';

export const getOrdersForOrderNumberPromise = (orderNumber) =>
  axios.get(`/order/search/orderNumber?orderNumber=${encodeURIComponent(orderNumber)}`).then((res) => res.data);

export const getOrdersForOrderNumber = (orderNumber) => {
  const urlEncodedOrderNumber = encodeURIComponent(orderNumber);
  const request = axios.get(`/order/search/orderNumber?orderNumber=${urlEncodedOrderNumber}`).then((response) => {
    const salesOrders = get(response, 'data', emptyArray);
    return new OrderSearchResultHandler({ salesOrders });
  });

  const data$ = from(request);
  return data$;
};

export const validateToteBarcode = (barcode) => {
  const urlEncodedBarcode = encodeURIComponent(barcode);
  const request = axios.get(`/mobile/totes/barcode/${urlEncodedBarcode}`).then((response) => get(response, 'data'));
  return from(request);
};

export const verifyShipment = (fulfillmentPlanId, { isVerified }) => {
  const requestBody = { isVerified, fulfillmentPlanId };
  const request = axios.post('/verify/fulfillmentPlan', requestBody);
  return from(request);
};
